// usage: useSelector(selector)
export const permissionsSelector = (store) => store.app.permissions;
